


























import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
@Component({
  name: "auto-video-enter-modal-component",
})
export default class AutoVideoEnterModalComponent extends Vue {
  get active() {
    return this.$store.getters["SystemStore/getAutoVideoEnterModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowAutoVideoEnterModalAction", e);
  }
  get roomId() {
    return this.$store.getters["SystemStore/getRoomId"];
  }
  onCancel() {
    this.active = false;
  }
  onEnter() {
    this.onCancel();
    this.$store.dispatch("SystemStore/setAutoVideoAction", true);
  }
}
